module.exports = __webpack_public_path__ + "static/benefits2-e38b41a52bcb5eff036158ca00c1b9ba.png";